import React, { useCallback, useMemo, useState } from "react";

import OrderItem from "./Item";
import OrderDetailOffcanvas from "../../Components/Common/OrderDetailOffcanvas";
import { getOrders } from "../../helpers/backend_helper";
import { useShopOrders } from "../../hooks/useShopOrders";

export interface StatusOrdersHandle {
    reload: () => void;
}

interface StatusOrdersProps {
    status: string | string[];
    sortBy: string;
    emptyMessage: string;
}

const StatusOrders = React.forwardRef<StatusOrdersHandle, StatusOrdersProps>(({ status, sortBy, emptyMessage }, ref) => {
    const statusParam = useMemo(() => (Array.isArray(status) ? status.join(",") : status), [status]);
    const [selectedOrderId, setSelectedOrderId] = useState<string | number | undefined>(undefined);
    const [isDetailOpen, setIsDetailOpen] = useState(false);

    const fetcher = useCallback(
        (_shopId: number) =>
            getOrders({
                status: statusParam,
                sort_by: sortBy,
                sort_order: "asc",
                per_page: 50,
            }),
        [sortBy, statusParam],
    );
    const { orders, loading, error, hasShop, reload } = useShopOrders(fetcher);

    React.useImperativeHandle(ref, () => ({
        reload,
    }), [reload]);
    const handleOpenDetail = (orderId: string | number) => {
        setSelectedOrderId(orderId);
        setIsDetailOpen(true);
    };

    const handleCloseDetail = () => {
        setIsDetailOpen(false);
    };

    return (
        <React.Fragment>
            {error && (
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            )}
            <div>
                <div className="row g-2">
                    {orders.map((item) => (
                        <div key={item.id} className="col-12">
                            <div className="card horizontal-product-card">
                                <OrderItem
                                    id={item.id}
                                    order_no={item.order_no ?? item.order_number}
                                    total={item.total ?? item.total_price ?? 0}
                                    opened_at={item.opened_at ?? item.created_at}
                                    status={item.status}
                                    order_type={item.order_type}
                                    zone_name_snapshot={item.zone_name_snapshot}
                                    table_number_snapshot={item.table_number_snapshot}
                                    onSelect={handleOpenDetail}
                                />
                            </div>
                        </div>
                    ))}
                </div>
                {loading && (
                    <div className="text-center py-4">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Đang tải...</span>
                        </div>
                    </div>
                )}
                {!loading && orders.length === 0 && hasShop && !error && (
                    <p className="text-center text-muted mt-3">{emptyMessage}</p>
                )}
            </div>
            <OrderDetailOffcanvas
                isOpen={isDetailOpen}
                orderId={selectedOrderId}
                onClose={handleCloseDetail}
                onActionComplete={reload}
            />
        </React.Fragment>
    );
});

StatusOrders.displayName = "StatusOrders";

export default StatusOrders;
